/**
 * Imperative "open the internal chat on this lead" channel.
 *
 * ChatDropdown holds all its state locally (open/view/activeThread are
 * useState in the Header), so nothing outside it could open a specific
 * thread — a message-toast click had nowhere to go. The dropdown subscribes
 * here on mount; a request raised before it mounts (or between remounts) is
 * kept and delivered to the next subscriber, so a toast clicked during a
 * route transition still lands.
 */
export interface ChatOpenRequest {
  leadId: number;
  /** Lets the dropdown open a chat view immediately even when the thread
   *  list hasn't caught up yet (brand-new conversation). */
  leadName?: string;
  /** Land ON this message (scroll + flash) — a mention / reply click-through. */
  messageId?: string;
  /** The deal channel the message lives on (`null`/absent = the lead chat). */
  childId?: number | null;
}

let listener: ((req: ChatOpenRequest) => void) | null = null;
let pending: ChatOpenRequest | null = null;

export function requestOpenChat(req: ChatOpenRequest) {
  if (listener) listener(req);
  else pending = req;
}

export function subscribeOpenChat(fn: (req: ChatOpenRequest) => void) {
  listener = fn;
  if (pending) {
    const req = pending;
    pending = null;
    fn(req);
  }
  return () => {
    if (listener === fn) listener = null;
  };
}
